import { render, staticRenderFns } from "./couponCollection.vue?vue&type=template&id=4fdab5c6&scoped=true&"
import script from "./couponCollection.vue?vue&type=script&lang=js&"
export * from "./couponCollection.vue?vue&type=script&lang=js&"
import style0 from "./couponCollection.vue?vue&type=style&index=0&id=4fdab5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdab5c6",
  null
  
)

export default component.exports